import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { InvalidFlow } from '@/modules/flowsV2/validation/types';
import { FlowCard } from '@/modules/flowsV2/components';
import { validateFlows } from '@/modules/flowsV2/validation/flowValidationSelector';
import { FddmServiceFactory as FloorplanDesignServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { Flow } from '@thive/fddm-types';

const AllLayoutFlowsComponent = () => {
  const { t } = useTranslation('interface');
  const fddmSvc = useMemo(
    () => FloorplanDesignServiceFactory.getInstance().createFddmService(),
    [],
  );
  const { flows } = useFloorplanDesignStore((state) => state.design.flows);
  const selectedIds = useAppStore((state) => state.selectedIds);
  const [invalidFlows, setInvalidFlows] = useState<InvalidFlow[]>([]);

  useEffect(() => {
    if (!flows?.length) return;

    const results = validateFlows(flows);
    // plz fix me
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setInvalidFlows(results);
  }, [flows]);

  const visibleFlows = useMemo(() => {
    // If flows are selected, show only selected flows
    if (selectedIds.length > 0) {
      return flows.filter((flow) => selectedIds.includes(flow.id));
    }
    // Otherwise show all flows
    return flows;
  }, [flows, selectedIds]);

  const getErrorForFlow = useCallback(
    (flowId: string) => invalidFlows.find((f) => f.flowId === flowId),
    [invalidFlows],
  );

  const onDelete = useCallback(
    (flow: Flow) => {
      fddmSvc.deleteFlows([flow]);
    },
    [fddmSvc],
  );

  if (!flows?.length) return null;

  return (
    <>
      {visibleFlows.map((flow) => (
        <FlowCard
          key={flow.id}
          flow={flow}
          tooltipTitle={t('properties.flows.delete.tooltip')}
          onDelete={onDelete}
          error={getErrorForFlow(flow.id)}
        />
      ))}
    </>
  );
};

export const AllLayoutFlows = memo(AllLayoutFlowsComponent);
